// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';

import Image from 'components/common/Image';
import LoadingDots from 'components/common/LoadingDots';

import loadingQrCodeSrc from 'assets/images/qrCode/loadingQrCode.png';

import styles from './QrCode.module.scss';

const QrCode = ({ url }) => {
  return (
    <React.Fragment>
      {url && (
        <Image
          className={styles.qrCode}
          src={url}
          alt="QR Code"
          data-testid="qr-code"
        />
      )}
      {!url && (
        <div className="position-relative">
          <Image
            className={styles.qrCode}
            src={loadingQrCodeSrc}
            alt="QR Code Loading"
            data-testid="qr-code-loading"
          />
          <div className={styles.loadingDots}>
            <LoadingDots />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

QrCode.propTypes = {
  url: PropTypes.string,
};

QrCode.defaultProps = {
  url: null,
};

export default QrCode;
